import { Checks, Copy, WarningCircle, X } from "@phosphor-icons/react";
import React, { useEffect, useState } from "react";
import axiosInstance from "../../api/axiosInstance";
import dayjs from "dayjs"; // Use for date/time formatting
import PageLoader from "../loader/PageLoader";
import { RejectHotel } from "./RejectAPI";
import { CompleteHotel } from "./CompleteAPI";
import {toast} from "react-toastify";
import PromoBreakdown from "./PromoBreakdown";
import { formatHotel } from "../../api/hotelTime";

const ConfirmPrice = ({ func, selectedRequest }) => {

    const hotelId = localStorage.getItem("hotelId");

    const [fee, setFee] = useState("");
    const [remarks, setRemarks] = useState("");
    const [driverName, setDriverName] = useState("");
    const [contact, setContact] = useState(null);
    const [vehicleNo, setVehicleNo] = useState(null);
    const [cabData, setCabData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [cabReqId, setCabReqId] = useState("");
    const [errors, setErrors] = useState({});
    const [guestRequestId, setGuestRequestId] = useState("");
    const [feeAccepted, setFeeAccepted] = useState(false);
    const [copied, setCopied] = useState(false);


    const [remarksError, setRemarksError] = useState(false);

    // Booking Name and Booking Contact Information
    const [bookingData,setBookingData] = useState({});


    // Fetch Data
    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await axiosInstance.get(
                    `/api/v1/hotels/${selectedRequest.hotelId}/bookings/${selectedRequest.bookingId}/booked-rooms/${selectedRequest.bookedRoomId}/guest-requests/pre-post-request/cab-request`,
                    {
                        params: {
                            guest_request_id: selectedRequest.requestId,
                        },
                    },
                );


                const bookingResponse = await axiosInstance.get(`/api/v1/hotels/${hotelId}/bookings/${selectedRequest.bookingId}`);
                // console.log("Booking Data : ",bookingResponse.data);
                setBookingData(bookingResponse.data);

                // console.log(response);
                let price = (response.data && response.data.price!=null && response.data.price!=undefined) ? response.data.price.toString() : "";
                setFee(price);

                if (response.data.price) setFeeAccepted(true);
                setRemarks(response.data.remarks);
                setDriverName(response.data.driver_name);
                setVehicleNo(response.data.vehicle_number);
                setContact(response.data.driver_contact);
                setCabReqId(response.data.id);
                setGuestRequestId(response.data?.guest_request_id);
                setCabData(response.data);
                setErrors("");
            } catch (error) {
                console.error("error occurred", error);
                setErrors({ fetch: "Error while fetching the data" });
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [selectedRequest]);

    // Validate Errors
    const validateErrors = () => {
   
        const newErrors = {};
        // If the driver is in-progress, validate all fields except remarks
  
        if (!fee) newErrors.fee = "Fee is required!";
        if((selectedRequest.status==="Pending_Hotel" && cabData.price) || selectedRequest.status==="InProgress_Hotel" || selectedRequest.status==="Scheduled_Hotel"){
     
            if (!driverName) newErrors.driverName = "Driver's name is required";
            if (!contact) newErrors.contact = "Driver's contact is required";
            else if (String(contact).replace(/\D/g, "").length < 10)
                newErrors.contact = "Driver's contact must be at least 10 digits";
            // if (!vehicleNo) newErrors.vehicleNo = "Vehicle number is required";
        }
         
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Respond to Guest
    const handleSubmit = async (isDeclined) => {
        // Validate before submission
        if (!validateErrors()) return;


        const updatedData = {
            is_declined: isDeclined,
            price: parseInt(fee),
            remarks: remarks,
            driver_name: driverName,
            driver_contact: parseInt(contact),
            vehicle_number: vehicleNo,
        };

        // console.log("Update Cab Data : ",updatedData);
 
        // return;

        try {
            const response = await axiosInstance.put(
                `/api/v1/hotels/${selectedRequest.hotelId}/bookings/${selectedRequest.bookingId}/booked-rooms/${selectedRequest.bookedRoomId}/guest-requests/pre-post-request/cab-request/${cabReqId}`,
                updatedData,
            );
            // console.log("success", response);

            func(false);
        } catch (error) {
            console.error("error occurred", error);
            setErrors({ update: "Error while updating the details" });
        }
    };

    // Reject Guest
    const handleRejectRequest = async () => {
        try {


            if(remarks.trim()==="") {
                setRemarksError(true);
                return;
            }

            const request = {
                hotelId: selectedRequest.hotelId,
                bookingId: selectedRequest.bookingId,
                guestRequestId: guestRequestId,
            };
            const response = await RejectHotel(request,remarks);
            if (response) func(false);
        } catch (error) {
            setErrors({ fetch: "Failed to reject Cab request" });
            console.log(error);
        }
    };

    // Extracting the relevant fields
    const {
        pick_up_location,
        drop_off_location,
        time_of_arrival,
        room_number,
        booked_room_id,
    } = cabData || "";

    // The guest accepting the fee moves the request back to the hotel's court,
    // so a priced request in any hotel-side status has been accepted. Waiting
    // on the guest is Pending_Guest, where there is nothing to acknowledge yet.
    const requestStatus = cabData?.status || selectedRequest.status;
    const guestAcceptedFee =
        feeAccepted &&
        (requestStatus === "Pending_Hotel" ||
            requestStatus === "InProgress_Hotel" ||
            requestStatus === "Scheduled_Hotel");

    const handleCopy = (text) => {
        navigator.clipboard.writeText(text).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000); // Reset copied state after 2 seconds
        });
    };


    // Complete Hotel
    const handleCompleteHotel = async()=>{
        try{

            // console.log("Cab Data Complete : " , cabData);
            const request = {
                hotelId: selectedRequest.hotelId,
                bookingId: selectedRequest.bookingId,
                guestRequestId: guestRequestId,
            };
            const response = await  CompleteHotel(request);
            toast.success("Taxi Request Completed")
            if (response) func(false);
        }catch(error){
            setErrors({ fetch: "Failed to Cab request" });
            console.log(error);
        }
    }



    // Format the date and time
    const tripDate = formatHotel(time_of_arrival, "DD MMMM YYYY");
    const tripTime = formatHotel(time_of_arrival, "hh:mm A");

    return (
        <div className="fixed top-0 left-0 h-screen w-screen bg-black bg-opacity-60 flex items-center justify-center z-[1001]">
            {loading && <PageLoader />}
            <form
                className="popup-content bg-white p-6 rounded-lg text-sm flex flex-col gap-2 w-[80%] md:w-[70%] lg:w-[50%]"
                onSubmit={(e) => e.preventDefault()}
            >
                <div className="flex items-center justify-between">
                    <h2 className="text-xl font-semibold">Cab To Hotel</h2>
                    <button
                        onClick={() => func(false)}
                        className="hover:bg-[#F2F7FF] p-1.5 border-[1.5px] rounded-md"
                        type="button"
                    >
                        <X weight="bold" size={18} />
                    </button>
                </div>

                <div className="flex flex-col gap-5">

                    <div className="grid grid-cols-4 gap-4 items-start">
                        <div className="min-w-0">
                            <p className="text-[#8C9199] mb-2">
                                {selectedRequest.roomNumber
                                    ? "Room Number"
                                    : "Booking ID"}
                            </p>
                            <div className="flex items-center gap-4">
                                <p
                                    className="truncate"
                                    title={booked_room_id}
                                >
                                    {selectedRequest.roomNumber ||
                                        booked_room_id}
                                </p>
                                <button
                                    onClick={() => handleCopy(booked_room_id)}
                                    className="text-gray-500 hover:text-blue-500 shrink-0"
                                    title="Copy to clipboard"
                                >
                                    {copied ? (
                                        <Checks size={16} />
                                    ) : (
                                        <Copy size={16} />
                                    )}
                                </button>
                            </div>
                        </div>

                        <div className="min-w-0">
                            <p className="text-[#8C9199] mb-2">
                                Booking Name
                            </p>
                            <p> {bookingData?.name || 'Booking Name'}</p>
                        </div>

                        <div className="min-w-0">
                            <p className="text-[#8C9199] mb-2">
                                Booking Contact
                            </p>
                            <p> +{bookingData?.contact || 'Booking Contact'}</p>
                        </div>

                       

                        <div className="min-w-0">
                            <p className="text-[#8C9199] mb-2">No. of people</p>
                            <p>{cabData?.number_of_people}</p>
                        </div>
                       

                    </div>
                    
                    <div className="grid grid-cols-4 gap-4 items-start">
                        <div className="min-w-0">
                            <p className="text-[#8C9199] mb-2">
                                Pickup Location
                            </p>
                            <p className="break-words">{pick_up_location}</p>
                        </div>
                        <div className="min-w-0">
                            <p className="text-[#8C9199] mb-2">
                                Drop-off Location
                            </p>
                            <p className="break-words">{drop_off_location}</p>
                        </div>
                        
                        <div className="min-w-0">
                            <p className="text-[#8C9199] mb-2">Trip Date</p>
                            <p>{tripDate}</p>
                        </div>

                        <div className="min-w-0">
                            <p className="text-[#8C9199] mb-2">
                                Requested Time
                            </p>
                            <p>{tripTime}</p>
                        </div>
                    </div>


                       


                    <div className="flex ">
                        <div className="">
                            <p className="text-[#8C9199]">Fee</p>
                            <div className="flex gap-3 w-full items-center">
                                <input
                                    type="text"
                                    value={fee}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        // Allow only numeric characters (0-9)
                                        if (/^\d*$/.test(value)) {
                                            setErrors((prev) => ({
                                                ...prev,
                                                fee: "",
                                            }));
                                            setFee(value); // Keep the value as string
                                        }
                                        else{
                                            setFee("");
                                        }
                                    }}
                                    placeholder="Enter amount"
                                    className="px-2 py-1.5 rounded-md border-[1.5px]"
                                    disabled={cabData?.status=="InProgress_Hotel" || cabData?.status==="Scheduled_Hotel"}
                                />
                                {guestAcceptedFee && (
                                    <p className="p-2 h-fit rounded-md bg-[#EDF9D5] text-[#39471B] font-medium flex items-center gap-2 text-sm">
                                        <Checks size={18} /> Accepted by
                                        guest
                                    </p>
                                )}
                            </div>
                            {errors.fee && (
                                <p className="text-[#ff7378] flex gap-1 items-center text-xs">
                                    <WarningCircle size={14} />
                                    {errors.fee}
                                </p>
                            )}
                        </div>
                    </div>

                    <PromoBreakdown
                        grossAmount={cabData?.price}
                        discountAmount={cabData?.discount_amount}
                        promotionId={cabData?.promotion_id}
                    />

                    {/* {selectedRequest.status === */}
                        {/* ("InProgress_Hotel" || "Scheduled_Hotel") && ( */}
                        {
                            (selectedRequest.status==="Pending_Hotel" || selectedRequest.status==="InProgress_Hotel" || selectedRequest.status==="Scheduled_Hotel") && cabData
                            && (cabData.price) 
                            &&
                            <div className="flex">
                                <div className="w-1/3">
                                    <p className="text-[#8C9199]">Driver's Name </p>
                                    <input
                                        type="text"
                                        value={driverName}
                                        onChange={(e) =>
                                            setDriverName(e.target.value)
                                        }
                                        placeholder="Enter driver's name"
                                        className="px-2 py-1.5 border-[1.5px] rounded-md mt-1"
                                    />
                                    {errors.driverName && (
                                        <p className="text-[#ff7378] flex gap-1 items-center text-xs">
                                            <WarningCircle size={14} />
                                            {errors.driverName}
                                        </p>
                                    )}
                                </div>
                                <div className="w-1/3">
                                    <p className="text-[#8C9199]">
                                        Driver's Contact{" "}
                                    </p>
                                    <input
                                        type="tel"
                                        value={contact}
                                        onChange={(e) => {
                                            setContact(
                                                e.target.value
                                                    .replace(/\D/g, "")
                                                    .slice(0, 10),
                                            );
                                            setErrors((prev) => ({
                                                ...prev,
                                                contact: "",
                                            }));
                                        }}
                                        placeholder="Enter driver's contact"
                                        className="px-2 py-1.5 border-[1.5px] rounded-md mt-1"
                                    />
                                    {errors.contact && (
                                        <p className="text-[#ff7378] flex gap-1 items-center text-xs">
                                            <WarningCircle size={14} />
                                            {errors.contact}
                                        </p>
                                    )}
                                </div>
                                <div className="w-1/3">
                                    <p className="text-[#8C9199]">Vehicle Number</p>
                                    <input
                                        type="text"
                                        value={vehicleNo}
                                        onChange={(e) => {
                                            setVehicleNo(e.target.value);
                                        }}
                                        placeholder="Enter vehicle number"
                                        className="px-2 py-1.5 border-[1.5px] rounded-md mt-1"
                                    />
                                    {errors.vehicleNo && (
                                        <p className="text-[#ff7378] flex gap-1 items-center text-xs">
                                            <WarningCircle size={14} />
                                            {errors.vehicleNo}
                                        </p>
                                    )}
                                </div>
                            </div>

                        }
                
                    {/* )} */}

                    
                    {/* Remarks */}
                    <div>
                        <p className="text-[#8C9199] mb-1">Remarks</p>
                        <textarea
                            value={remarks || ""}
                            onChange={(e) => {  
                                const value = e.target.value;
                                setRemarks(value);
                                setRemarksError(false)}}
                            rows={4}
                            className="w-full border-[1.5px] rounded-md p-2"
                            placeholder="Please leave your remarks here"
                        ></textarea>
                        {remarksError && (
                            <p className="text-[#ff7378] flex gap-1 items-center text-xs mt-1">
                                <WarningCircle size={14} />
                                remarks is required when you reject the request
                            </p>
                        )}
                    </div>
                    
                    {errors.fetch && (
                        <p className="text-red-500">{errors.fetch}</p>
                    )}
                    {errors.update && (
                        <p className="text-red-500">{errors.update}</p>
                    )}
                    
                    
                    {/* Buttons */}
                    <div className="grid grid-cols-3 gap-3 mt-3">
                        <button
                            className="p-2 w-full  rounded-md  bg-[#ff7378] font-medium text-[#262B33]"
                            onClick={() => handleSubmit(false)} // Respond to guest
                            type="button"
                        >
                            Respond To Guest
                        </button>
                        <button className="p-2 w-full border-[1.5px] bg-[#73c9ff] rounded-md font-medium hover:bg-[#5fa4f7] transition duration-150 outline-none" onClick={()=>handleCompleteHotel()} >
                            Complete Request
                        </button>
                        <button
                            className="p-2 w-full border-[1.5px] rounded-md border-[#F5CCD3] text-[#D02746] font-medium"
                            onClick={handleRejectRequest} // Reject request
                            type="button"
                        >
                            Reject Request
                        </button>
                    </div>

                </div>
            </form>
        </div>
    );
};

export default ConfirmPrice;
